module.exports = __webpack_public_path__ + "514a87ee5ec7723a3fd271f889ff3d05.glb";